<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <!--<v-icon @click="pushRouteToView('bms')" class="mr-4" style="cursor: pointer">
                                  mdi-arrow-left
                              </v-icon>-->
                    <v-row>
                        <v-col md="12">

                            <v-btn
                                small
                                @click="pushRouteToView()"
                                class="mr-4 btn-back"
                            >
                                <v-icon> mdi-arrow-left</v-icon>
                                Voltar
                            </v-btn>

                            <v-icon left>mdi-hair-dryer-outline</v-icon>
                            <span v-if="bm.id">Editar&nbsp; </span>
                            <span v-else>Adicionar&nbsp; </span>
                            Profissional
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-card-text>
                    <v-form
                        ref="formBM"
                        v-model="formIsValid"
                        v-on:submit.prevent="bmSubmit(bm.id)"
                    >
                        <v-col md="12">
                            <v-row>
                                <v-col xl="6" lg="6" md="6" sm="12">
                                    <v-text-field
                                        v-model="bm.nickname"
                                        @blur="bm.nickname=bm.nickname.toUpperCase()"
                                        :rules="textRules"
                                        label="Como deseja ser chamado"
                                        placeholder="Como deseja ser chamado"
                                        hint="Como é conhecido profissionalmente"
                                        append-icon="mdi-account"
                                        maxlength="200"
                                        counter
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col xl="6" lg="6" md="6" sm="12">
                                    <v-switch
                                        v-model="bm.assistant"
                                        label="Assistente"
                                    ></v-switch>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col xl="6" lg="6" md="6" sm="12" xs="12" cols="12">
                                    <v-text-field
                                        v-model="bm.name"
                                        @blur="bm.name=bm.name.toUpperCase()"
                                        :rules="textRules"
                                        label="Nome"
                                        placeholder="Nome"
                                        append-icon="mdi-account"
                                        maxlength="200"
                                        counter
                                        outlined
                                        dense

                                    ></v-text-field>
                                </v-col>
                                <v-col xl="3" lg="3" md="3" sm="6" xs="12" cols="12">
                                    <v-text-field
                                        v-model="bm.cpf"
                                        v-mask="['###.###.###-##']"
                                        label="CPF"
                                        placeholder="Informe o CPF"
                                        :rules="cpfRule"
                                        outlined
                                        append-icon="mdi-card-account-details-outline"
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col xl="3" lg="3" md="3" sm="6" xs="12" cols="12">
                                    <v-text-field
                                        v-model="bm.cnpj"
                                        v-mask="['##.###.###/####-##']"
                                        label="CNPJ"
                                        placeholder="Informe o CNPJ"
                                        :rules="cnpjRules"
                                        outlined
                                        append-icon="mdi-card-account-details-outline"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-show="!bm.assistant">
                                <v-col xl="3" lg="3" md="4" sm="6" xs="12" cols="12">
                                    <v-select
                                        v-model="bm.serviceStepTime"
                                        :items="items"
                                        item-text="desc"
                                        item-value="value"
                                        label="Fator Tempo de Serviço"
                                        :rules="[bmAssistantRules]"
                                        outlined
                                        dense
                                    ></v-select>
                                </v-col>
                                <v-col xl="3" lg="3" md="4" sm="6" xs="12" cols="12">
                                    <number-input
                                        label="Comissão Sobre Produto"
                                        append-icon="mdi-percent"
                                        v-model="bm.commissionProduct"
                                        placeholder="Comissão Sobre Produto"
                                        :rules="[bmAssistantRules]"
                                        outlined
                                        :options="optionsCommission"
                                        dense
                                    >
                                    </number-input>
                                </v-col>
                                <v-col xl="3" lg="3" md="4" sm="6" xs="12" cols="12">
                                    <number-input
                                        label="Comissão Sobre Insumo"
                                        append-icon="mdi-percent"
                                        v-model="bm.commissionSupply"
                                        placeholder="Comissão Sobre Insumo"
                                        :rules="[bmAssistantRules]"
                                        outlined
                                        :options="optionsCommission"
                                        dense
                                    ></number-input>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                                    <v-text-field
                                        v-model="bm.obs"
                                        @blur="bm.obs=bm.obs.toUpperCase()"
                                        label="Observação"
                                        placeholder="Digite uma Observação - Uso interno"
                                        maxlength="400"
                                        append-icon="mdi-format-align-justify"
                                        counter
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>
                                
                            </v-row>
                            <v-row>
                                <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" v-show="!bm.assistant">
                                    <v-text-field
                                        v-model="bm.desc"
                                        @blur="bm.desc=bm.desc.toUpperCase()"
                                        :rules="[bmAssistantRules]"
                                        counter
                                        maxlength="220"
                                        label="Descrição"
                                        placeholder="Descrição para o Aplicativo"
                                        outlined
                                        append-icon="mdi-format-align-justify"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12" v-show="!bm.assistant">
                                    <v-text-field
                                        v-model="bm.pixkey"
                                        @blur="bm.pixkey"
                                        counter
                                        maxlength="100"
                                        label="Chave Pix"
                                        placeholder="Chave Pix para resgate de saldo"
                                        outlined
                                        append-icon="mdi-format-align-justify"
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-show="!bm.id && !bm.assistant">
                                <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
                                    <v-file-input
                                        v-model="img"
                                        accept="image/png, image/jpeg"
                                        placeholder="Escolha uma imagem."
                                        append-icon="mdi-camera"
                                        prepend-icon=""
                                        label="Imagem"
                                        outlined
                                        :rules="imageRules"
                                        @change="previewImage"
                                        dense
                                    ></v-file-input>
                                </v-col>
                            </v-row>
                            <v-row v-show="!bm.id">
                                <v-col>
                                    <v-card elevation="5" justify="center" align="center" class="pa-1 float-left" v-show="bm.image">
                                        <v-avatar size="256">
                                            <v-img :src="bm.image"
                                                   max-height="256px"
                                                   max-width="256px"
                                                   :aspect-ratio="1"></v-img>
                                        </v-avatar>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="12" class="text-right">
                                    <v-btn
                                        color="#FF3816"
                                        dark
                                        v-if="bm.id"
                                        class="mr-4"
                                        @click="reset"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                        Cancelar
                                    </v-btn>
                                    <!--
                                                      <v-btn
                                                          color="warning"
                                                          dark
                                                          v-else
                                                          class="mr-4"
                                                          @click="reset"
                                                      >
                                                          <v-icon>mdi-eraser</v-icon>
                                                          Limpar
                                                      </v-btn>-->
                                    <v-btn
                                        dark
                                        v-else
                                        class="mr-4 btn-cancel"
                                        @click="pushRouteToView('bms')"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                        Cancelar
                                    </v-btn>
                                    <v-btn type="submit" color="success">
                                        <v-icon left v-if="bm.id">mdi-content-save</v-icon>
                                        <v-icon left v-else>mdi-content-save</v-icon>
                                        Salvar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";
import NumberInput from "@/components/NumberInput";

import {BM_GET, BM_EDIT, BM_CREATE} from "@/store/actions/bm.type";
import {WEEKDAYS_GET} from "@/store/actions/weekday.type";
import {SERVICES_GET} from "@/store/actions/service.type";
import {
    BM_ADD_SERVICE,
    BM_ADD_WEEKDAY,
    BM_REMOVE_SERVICE,
    BM_REMOVE_WEEKDAY,
    BM_RESET,
    BM_RESET_STATE,
    SET_BM_IMAGE,
} from "@/store/mutations/bm.type";
import {UPDATE_PERMISSION} from "@/store/mutations/user.type";
import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";
import {validarCNPJ} from "@/common/cnpj.service";
import {validarCPF} from "@/common/cpf.service";
import {resizeImage} from "@/common/image.service";

// import router from "@/router";

export default {
    name: "BMEdit",
    directives: {mask},
    props: {
        id: {
            default: 0,
            type: Number,
            required: false,
        },
    },

    components: {NumberInput},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.dispatch(BM_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await store.dispatch(BM_RESET_STATE);

        if (to.params.id !== undefined && to.params.id !== 0) {
            await store.dispatch(BM_GET, to.params.id)
        }
        await store.dispatch(SERVICES_GET);
        await store.dispatch(WEEKDAYS_GET);

        return next();
    },
    data: () => ({
        items: [
            {value: 5, desc: "5 minutos"},
            {value: 10, desc: "10 minutos"},
            {value: 15, desc: "15 minutos"},
            {value: 20, desc: "20 minutos"},
            {value: 30, desc: "30 minutos"},
            {value: 60, desc: "60 minutos"},
        ],
        img: null,
        selectMaterialOK: "",
        formIsValid: false,

        optionsCommission: {
            locale: "pt-BR",
            prefix: "",
            length: 4,
            precision: 2,
        },

        imageRules: [
            (value) =>
                !value || value.size < 10000000 || "O tamanho máximo da imagem é 10MB",
            (value) => {
                if (typeof value !== "undefined" && value !== null) {
                    if (value.type !== "image/jpeg" && value.type !== "image/png") {
                        return "Envie uma imagem JPG ou PNG";
                    }
                }
                return true;
            },
        ],
        textRules: [
            (v) => !!v || "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        numberRules: [
            (v) => {
                if (typeof v !== "undefined" && v !== null) {
                    if (!isNaN(v) && v >= 0.0 && v <= 100) return true;
                }
                return "Informe um valor de 0 a 100";
            },
        ],
        cpfRule: [
            (v) => !!v || "CPF é obrigatório",
            (strCPF) => validarCPF(strCPF) || "Informe um CPF válido.",
        ],
        cnpjRules: [
            (v) => {
                if (typeof v !== "undefined" && v !== null) {
                    if (v !== "") {
                        return validarCNPJ(v) || "Informe um CNPJ válido.";
                    }
                }
                return true;
            },
        ],
        fileRules: [
            (value) => !!value || "Campo obrigatório.",
            // value => !value || value.size < 2000000 || "A imagem tem que ter menos de  2 MB!",
        ],
        emailRules: [
            (v) => !!v || "E-mail é obrigatório",
            (value) => {
                if (typeof value !== "undefined" && value !== null) {
                    if (value.length > 0) {
                        const pattern =
                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || "Informe um email válido";
                    }
                }
                return false;
            },
        ],
        hourRules: [
            (v) => !!v || "Campo obrigatório",
            (value) => {
                if (typeof value !== "undefined" && value !== null) {
                    if (value.length > 0) {
                        const pattern = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
                        return pattern.test(value) || "Informe um horário válido";
                    }
                }
                return false;
            },
        ],
        telRules: [
            (v) => !!v || "Telefone é obrigatório",
            (value) => {
                if (typeof value !== "undefined" && value !== null) {
                    if (value.length > 0) {
                        const pattern = /(\(?\d{2}\)?\s)?(\d{4,5}-\d{4})$/;
                        return pattern.test(value) || "Informe um telefone válido";
                    }
                }
                return false;
            },
        ],
    }),
    methods: {
    bmAssistantRules(v){
        if(this.bm.assistant){
         return true;   
        }
        
        return !!v || "Este campo é obrigatório"
    },
        pushRouteToView() {
            if (this.bm.id) {
                this.$router.push({name: "bm", params: {id: this.bm.id}});
            } else {
                this.$router.push({name: "bms"});
            }

        },

        async previewImage() {
            if (this.img) {
                if (this.img.type !== "image/jpeg" && this.img.type !== "image/png") {
                    store.commit(SET_BM_IMAGE, "");
                    return;
                }

                resizeImage({
                    // file: this.img img.target.files[0],
                    file: this.img,
                    maxWidth: 256,
                    maxHeight: 256,
                    base64: true
                }).then(async (imageFile) => {
                    store.commit(SET_BM_IMAGE, imageFile);
                }).catch(function (err) {
                    console.log(err)
                    this.$store.commit(CHANGE_PROGRESS, false)

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Salvar.";

                });

                // const toBase64 = (file) =>
                //     new Promise((resolve, reject) => {
                //         const reader = new FileReader();
                //         reader.readAsDataURL(file);
                //         reader.onload = () => resolve(reader.result);
                //         reader.onerror = (error) => reject(error);
                //     });
                //
                // store.commit(SET_BM_IMAGE, await toBase64(this.img));
            } else {

                store.commit(SET_BM_IMAGE, "");


            }
        },
        durationRule(v) {
            if (!v) {
                return "Este campo é obrigatório";
            }
            if (typeof v !== "undefined" && v !== null) {
                if (v % this.bm.serviceStepTime !== 0) {
                    return "Este campo precisa ser múltiplo do fator de serviço";
                }
            }
            return true;
        },
        addService() {
            if (this.bm.services.length < this.servicesSimple.length)
                this.$store.commit(BM_ADD_SERVICE);
        },
        removeService(index) {
            if (this.bm.services.length > 1)
                this.$store.commit(BM_REMOVE_SERVICE, index);
        },
        addWeekDay() {
            this.$store.commit(BM_ADD_WEEKDAY);
        },
        removeWeekDay(index) {
            if (this.bm.weekDays.length > 1)
                this.$store.commit(BM_REMOVE_WEEKDAY, index);
        },

        permissionValue(permission) {
            let permLevel = this.bm.permissions.find((p) => p.id === permission);
            if (typeof permLevel !== "undefined") {
                return {id: permLevel.levelID};
            }
            return null;
        },
        updatePermissions(permission, level) {
            this.permissions.find((p, i) => {
                if (p.id === permission.id) {
                    let permission = {id: p.id, levelID: level.id};
                    this.$store.commit(UPDATE_PERMISSION, {
                        i: i,
                        permission: permission,
                    });
                    // this.bm.permissions[i] = {id: p.id, levelID: level.id};
                }
            });
        },
        passwordRule(pass) {
            if (!pass && this.id != 0) return true;
            return !!pass || "Este campo é obrigatório";
        },
        reset() {
            if (this.$route.params.id > 0) {
                this.$router.go(-1);
            } else {
                this.$refs.formBM.resetValidation();

                store.commit(BM_RESET);
            }
        },
        bmSubmit(id) {
            if (this.$refs.formBM.validate()) {
                let action = id ? BM_EDIT : BM_CREATE;
                this.$store.commit(CHANGE_PROGRESS, true);

                // this.bloqueiaEnvio = true;
                this.$store
                    .dispatch(action)
                    .then((response) => {
                        this.$store.commit(CHANGE_PROGRESS, false);
                        this.bloqueiaEnvio = false;

                        this.$refs.formBM.resetValidation();
                        // store.commit(BM_RESET);
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";
                        if (response.data.id) {
                            this.$router.push({
                                name: "bm",
                                params: {id: response.data.id},
                            });
                        } else {
                            this.$router.push({
                                name: "bm",
                                params: {id: id},
                            });
                        }
                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false);
                        this.snackbar.bloqueiaEnvio = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar Beauty Maker.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro ao salvar Beauty Maker: " + response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },
    },
    mounted() {
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["bm", "permissions", "servicesSimple", "snackbar", "weekDays"]),
    },
    watch: {},
};
</script>
